import { message, Row, Col, Divider, Empty } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  SelectEscuelasItem,
  SegmentedItem,
  ErrorItem,
} from "../../../../Components/Items";
import SelectGruposEscuelaItem from "../../../../Components/SelectGruposEscuelaItem";
import { Select } from "antd";

const { Option } = Select;

class AlumnoModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoTiposCliente: [],
    escuelaIdSeleccionada: undefined,
    inicializandoForm: false,
    modo: "nuevo",
    alumnosExistentes: [],
    cargandoExistentes: false,
    alumnoExistenteId: undefined,
  };

  constructor(props) {
    super(props);
    this.buscarAlumnosExistentes = debounce(
      this.buscarAlumnosExistentes.bind(this),
      300,
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      if (this.formRef.current) this.formRef.current.resetFields();
      this.setState({
        escuelaIdSeleccionada: undefined,
        modo: "nuevo",
        alumnosExistentes: [],
        alumnoExistenteId: undefined,
        cargandoExistentes: false,
      });
      this.cargarTiposCliente();

      const { escuelaIdInicial, grupoEscuelaIdInicial } = this.props;
      if (escuelaIdInicial || grupoEscuelaIdInicial) {
        this.setState({ inicializandoForm: true });

        
        setTimeout(() => {
          if (escuelaIdInicial) {
            this.formRef.current?.setFieldsValue({
              escuelaId: escuelaIdInicial,
            });
            this.onChangeEscuela(escuelaIdInicial);
          }
          if (grupoEscuelaIdInicial) {
            this.formRef.current?.setFieldsValue({
              grupoEscuelaId: grupoEscuelaIdInicial,
            });
          }
        }, 0);

        
        if (grupoEscuelaIdInicial) {
          [200, 600].forEach((ms) =>
            setTimeout(() => {
              if (!this.props.visible) return;
              this.formRef.current?.setFieldsValue({
                grupoEscuelaId: grupoEscuelaIdInicial,
              });
            }, ms),
          );
        }

        setTimeout(
          () => this.setState({ inicializandoForm: false }),
          800,
        );
      }
    }
  }

  cargarTiposCliente = () => {
    axios
      .post(
        "tiposdeclientes/selectTiposDeClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        const lista = Array.isArray(res.data) ? res.data : [];
        this.setState({
          objetoTiposCliente: lista.map((v) => (
            <Option key={v._id} value={v._id}>
              {v.nombre}
            </Option>
          )),
        });
      })
      .catch(() => {});
  };

  onChangeEscuela = async (escuelaId) => {
    this.setState({ escuelaIdSeleccionada: escuelaId });
    if (!this.state.inicializandoForm) {
      this.formRef.current?.setFieldsValue({ grupoEscuelaId: undefined });
    }

    // Al cambiar de escuela en modo existente, refrescar la lista
    if (this.state.modo === "existente") {
      this.setState({
        alumnoExistenteId: undefined,
        alumnosExistentes: [],
      });
      this.buscarAlumnosExistentes("");
    }

    if (!escuelaId) {
      this.formRef.current?.setFieldsValue({ tipoClienteId: undefined });
      return;
    }
    try {
      const res = await axios.post(
        "escuelas/datosEscuela",
        { escuelaId },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2 && res.data.escuela?.tipoDeClienteId) {
        this.formRef.current?.setFieldsValue({
          tipoClienteId: res.data.escuela.tipoDeClienteId,
        });
      }
    } catch (e) {}
  };

  buscarAlumnosExistentes(query = "") {
    this.setState({ cargandoExistentes: true });
    const escuelaId =
      this.state.escuelaIdSeleccionada ||
      this.formRef.current?.getFieldValue("escuelaId");

    axios
      .post(
        "alumnos/selectAlumnosSinGrupo",
        {
          empresaId: this.props.empresaId,
          escuelaId,
          query,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ alumnosExistentes: res.data.data || [] });
        } else {
          this.setState({ alumnosExistentes: [] });
        }
      })
      .catch(() => this.setState({ alumnosExistentes: [] }))
      .finally(() => this.setState({ cargandoExistentes: false }));
  }

  onChangeModo = (modo) => {
    this.setState({ modo, alumnoExistenteId: undefined });
    if (modo === "existente") {
      this.buscarAlumnosExistentes("");
    }
  };

  asignarAlumnoExistente = () => {
    const { alumnoExistenteId } = this.state;
    const grupoEscuelaId =
      this.formRef.current?.getFieldValue("grupoEscuelaId");

    if (!alumnoExistenteId) {
      message.info("Selecciona un alumno");
      return;
    }
    if (!grupoEscuelaId) {
      message.info("Selecciona un grupo");
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "alumnos/asignarAlumnoAGrupo",
        {
          empresaId: this.props.empresaId,
          alumnoId: alumnoExistenteId,
          grupoEscuelaId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Alumno asignado al grupo");
          this.cerrarModal(true);
        } else {
          message.error(res.data.message || "No se pudo asignar el alumno");
        }
      })
      .catch(() => message.error("Error al comunicarse con el servidor"))
      .finally(() => this.setState({ loading: false }));
  };

  onFinish = (values) => {
    if (this.state.modo === "existente") {
      this.asignarAlumnoExistente();
      return;
    }

    if (!values?.nombre) {
      message.info("Ingresa al menos el nombre del alumno");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "alumnos/agregarAlumno",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Alumno agregado");
          this.cerrarModal(true);
        } else {
          message.error(res.data.message || "No se pudo agregar el alumno");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  cerrarModal = (recargar = false) => {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrarModal(recargar);
  };

  render() {
    const sectionTitleStyle = {
      fontSize: 12,
      color: "#8c8c8c",
      letterSpacing: 0.4,
      textTransform: "uppercase",
      fontWeight: 600,
    };
    const dividerStyle = { margin: "4px 0 12px" };
    const esModoExistente = this.state.modo === "existente";

    return (
      <ModalItem
        title="Agregar Alumno"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal(false)}
        width={880}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 18,
          }}
        >
          <SegmentedItem
            value={this.state.modo}
            onChange={this.onChangeModo}
            options={[
              { label: "Crear nuevo", value: "nuevo" },
              { label: "Asignar existente", value: "existente" },
            ]}
          />
        </div>

        <Form
          ref={this.formRef}
          name="modalAlumno"
          layout="vertical"
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              className="botonAgregar"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              {esModoExistente ? "Asignar al grupo" : "Guardar"}
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={(e) => ErrorItem(e)}
        >
          <Divider orientation="left" style={dividerStyle}>
            <span style={sectionTitleStyle}>Asignación escolar</span>
          </Divider>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <FormItem name="escuelaId" label="Escuela" required margin>
                <SelectEscuelasItem
                  placeholder="Selecciona la escuela"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  onChange={this.onChangeEscuela}
                />
              </FormItem>
            </Col>
            <Col xs={24} sm={12}>
              <FormItem name="grupoEscuelaId" label="Grupo" margin>
                <SelectGruposEscuelaItem
                  placeholder="Selecciona el grupo"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  escuelaId={this.state.escuelaIdSeleccionada}
                  allowClear
                />
              </FormItem>
            </Col>
          </Row>

          {esModoExistente ? (
            <>
              <Divider orientation="left" style={dividerStyle}>
                <span style={sectionTitleStyle}>Alumno a asignar</span>
              </Divider>

              <FormItem
                label="Buscar alumno"
                margin
                tooltip="Si el alumno ya pertenece a otro grupo, se mostrará entre paréntesis y al asignarlo se moverá al nuevo grupo."
              >
                <Select
                  showSearch
                  allowClear
                  filterOption={false}
                  placeholder="Busca por nombre, matrícula o correo"
                  value={this.state.alumnoExistenteId}
                  onSearch={this.buscarAlumnosExistentes}
                  onChange={(value) =>
                    this.setState({ alumnoExistenteId: value })
                  }
                  loading={this.state.cargandoExistentes}
                  style={{ width: "100%" }}
                  notFoundContent={
                    this.state.cargandoExistentes ? (
                      "Buscando..."
                    ) : (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No se encontraron alumnos"
                      />
                    )
                  }
                  onFocus={() => {
                    if (this.state.alumnosExistentes.length === 0) {
                      this.buscarAlumnosExistentes("");
                    }
                  }}
                >
                  {this.state.alumnosExistentes.map((a) => (
                    <Option key={a._id} value={a._id}>
                      {a.stringBuscar}
                    </Option>
                  ))}
                </Select>
              </FormItem>
            </>
          ) : (
            <>
              <Divider orientation="left" style={dividerStyle}>
                <span style={sectionTitleStyle}>Datos del alumno</span>
              </Divider>

              <Row gutter={16}>
                <Col xs={24} sm={8}>
                  <FormItem name="nombre" label="Nombre" required margin>
                    <InputItem placeholder="Nombre" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={8}>
                  <FormItem
                    name="apellidoPaterno"
                    label="Apellido paterno"
                    margin
                  >
                    <InputItem placeholder="Apellido paterno" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={8}>
                  <FormItem
                    name="apellidoMaterno"
                    label="Apellido materno"
                    margin
                  >
                    <InputItem placeholder="Apellido materno" />
                  </FormItem>
                </Col>
              </Row>

              <Divider orientation="left" style={dividerStyle}>
                <span style={sectionTitleStyle}>Contacto</span>
              </Divider>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <FormItem name="correo" label="Correo" margin>
                    <InputItem placeholder="correo@ejemplo.com" />
                  </FormItem>
                </Col>
                <Col xs={12} sm={6}>
                  <FormItem name="telefono" label="Teléfono" margin>
                    <InputNumberItem
                      placeholder="Teléfono"
                      celular
                      style={{ width: "100%" }}
                    />
                  </FormItem>
                </Col>
                <Col xs={12} sm={6}>
                  <FormItem name="celular" label="Celular" margin>
                    <InputNumberItem
                      placeholder="Celular"
                      celular
                      style={{ width: "100%" }}
                    />
                  </FormItem>
                </Col>
              </Row>

              <Divider orientation="left" style={dividerStyle}>
                <span style={sectionTitleStyle}>Información académica</span>
              </Divider>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <FormItem name="matricula" label="Matrícula" margin>
                    <InputItem placeholder="Ej: A01234567" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12}>
                  <FormItem name="nivelPrepare" label="Nivel Prepare" margin>
                    <InputItem placeholder="Nivel Prepare" />
                  </FormItem>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <FormItem name="nivelIngles" label="Nivel inglés" margin>
                    <InputNumberItem
                      placeholder="0 - 10"
                      min={0}
                      max={10}
                      step={0.1}
                      style={{ width: "100%" }}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12}>
                  <FormItem
                    name="tipoClienteId"
                    label="Tipo de cliente"
                    margin
                    tooltip="Se selecciona automáticamente desde la escuela. Puedes cambiarlo si lo necesitas."
                  >
                    <SelectItem
                      placeholder="Selecciona un tipo de cliente"
                      allowClear
                    >
                      {this.state.objetoTiposCliente}
                    </SelectItem>
                  </FormItem>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AlumnoModal);
